import intl from 'react-intl-universal';
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { ExchangeGoodType, NewGoodType, OldGoodType } from '@/type/components';
import { useEffect } from 'react';
import { useState } from 'react';
import NewGood from '../NewGood';
import OldGood from '../OldGood';
import SelectNewProduct from '../SelectNewProduct';
import SelectOldProduct from '../SelectOldProduct';
import styles from './index.less';

type AddGoodItemProps = {
    index: number;
    value?: ExchangeGoodType;
    /** 1:原商品；2:新商品；3：原商品+新商品；默认 3 */
    mode?: 1 | 2 | 3;
    onChange?: (value: ExchangeGoodType) => void;
    disable: boolean;
    aftersaleType: number;
    orderCreatedTime?: string;
    sessionId?: string;
};

const AddGoodItem: React.FC<AddGoodItemProps> = ({
    index,
    value,
    mode = 3,
    onChange,
    disable,
    aftersaleType,
    orderCreatedTime,
    sessionId,
}) => {
    const [oldVisible, setOldVisible] = useState(false);
    const [newVisible, setNewVisible] = useState(false);

    const [oldGood, setOldGood] = useState<OldGoodType | undefined>(
        value?.oldGoods,
    );
    const [newGood, setNewGood] = useState<NewGoodType | undefined>(
        value?.newGoods,
    );

    useEffect(() => {
        onChange &&
            onChange({
                oldGoods: oldGood,
                newGoods: newGood,
            });
    }, [oldGood, newGood]);

    return (
        <div className={styles.container}>
            {mode !== 2 ? (
                <OldGood
                    title={intl.get('原商品{index}：', { index: index })}
                    good={oldGood}
                    aftersaleType={aftersaleType}
                    orderCreatedTime={orderCreatedTime}
                    editGood={() => setOldVisible(true)}
                    disable={disable}
                />
            ) : null}

            {mode !== 1 ? (
                <NewGood
                    title={intl.get('新商品{index}：', { index: index })}
                    good={newGood}
                    editGood={() => setNewVisible(true)}
                    disable={disable}
                />
            ) : null}

            {/* 添加编辑旧商品 */}
            {oldVisible ? (
                <SelectOldProduct
                    open={oldVisible}
                    onOpenChange={setOldVisible}
                    value={oldGood}
                    aftersaleType={aftersaleType}
                    onValueChange={(product) => {
                        const { isSameChange } = product;
                        setOldGood(product);
                        setOldVisible(false);
                        if (isSameChange) {
                            setNewGood({
                                seriesName: product.seriesName,
                                productCode: product.productCode,
                                productImage: product.productImage,
                                productName: product.productName,
                            });
                        }
                    }}
                    showSameChange={mode === 3}
                    sessionId={sessionId}
                />
            ) : null}

            {/* 添加编辑新商品 */}
            {newVisible ? (
                <SelectNewProduct
                    open={newVisible}
                    onOpenChange={setNewVisible}
                    value={newGood}
                    onValueChange={(product) => {
                        setNewGood(product);
                        setNewVisible(false);
                    }}
                />
            ) : null}
        </div>
    );
};

export default AddGoodItem;
